// extracted by mini-css-extract-plugin
export var content = "index-module--content--6afe8";
export var copiedContent = "index-module--copiedContent--af825";
export var desc = "index-module--desc--0da2f";
export var entry = "index-module--entry--f4a57";
export var item = "index-module--item--6f74f";
export var label = "index-module--label--96c5f";
export var left = "index-module--left--8d1a7";
export var links = "index-module--links--3331c";
export var right = "index-module--right--5d5a4";
export var section = "index-module--section--f0f6f";
export var srcondBg = "index-module--srcondBg--52435";
export var subDesc = "index-module--subDesc--d30a5";
export var title = "index-module--title--96741";